export interface GraphPalette {
  id: string;
  name: string;
  colors: string[];
}

export const GRAPH_PALETTES: GraphPalette[] = [
  {
    id: 'capitol',
    name: 'Capitol',
    colors: [
      'var(--chart-1)',
      'var(--chart-2)',
      'var(--chart-3)',
      'var(--chart-4)',
      'var(--chart-5)',
      'var(--chart-6)',
      'var(--chart-7)',
      'var(--chart-8)',
      'var(--chart-9)',
      'var(--chart-10)',
    ],
  },
  {
    id: 'aurora',
    name: 'Aurora',
    colors: [
      '#8b5cf6',
      '#06b6d4',
      '#f472b6',
      '#34d399',
      '#f59e0b',
      '#60a5fa',
      '#fb7185',
      '#a3e635',
    ],
  },
  {
    id: 'ocean',
    name: 'Ocean',
    colors: [
      '#0ea5e9',
      '#14b8a6',
      '#6366f1',
      '#22d3ee',
      '#3b82f6',
      '#2dd4bf',
      '#818cf8',
      '#0284c7',
    ],
  },
  {
    id: 'ember',
    name: 'Ember',
    colors: [
      '#f97316',
      '#e11d48',
      '#eab308',
      '#ec4899',
      '#f59e0b',
      '#ef4444',
      '#fb923c',
      '#d946ef',
    ],
  },
  {
    // Paul Tol's "bright" qualitative scheme — distinguishable under the
    // common forms of color-vision deficiency on both light and dark surfaces.
    id: 'colorblind-safe',
    name: 'Colorblind safe',
    colors: [
      '#4477aa',
      '#ee6677',
      '#228833',
      '#ccbb44',
      '#66ccee',
      '#aa3377',
      '#bbbbbb',
    ],
  },
];

export const DEFAULT_PALETTE_ID = 'capitol';

export const PALETTE_STORAGE_KEY = 'context-graph-viewer-palette';

export const getStoredPalette = (): GraphPalette => {
  const storedId = localStorage.getItem(PALETTE_STORAGE_KEY);
  return (
    GRAPH_PALETTES.find((palette) => palette.id === storedId) ??
    GRAPH_PALETTES.find((palette) => palette.id === DEFAULT_PALETTE_ID)!
  );
};
